module.exports = __webpack_public_path__ + "static/media/dwolla-api-layer.d0ffbdf8.jpg";